import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import FullCurrencyConverter from 'components/FullCurrencyConverter';

import {
  makeGetLocationParamsValues,
  getCurrencyRatesByCurrencyPair,
  getConverterTypesOptions,
  getCurrenciesItems,
  getCurrenciesFetching,
  getTimestamp,
  getExistedConverterType,
  getCurrenciesPairInfo,
  getCurrencyRatesIsFetching,
} from 'selectors';

const getLocationParamsValues = makeGetLocationParamsValues();

const mapStateToProps = (state, props) => {
  const locationParamsValues = getLocationParamsValues(state, props);
  const currencyRatesByCurrencyPair = getCurrencyRatesByCurrencyPair(
    state,
    props
  );
  const currenciesPairInfo = getCurrenciesPairInfo(state, props);
  const timestamp = getTimestamp(state, props);
  const existedConverterType = getExistedConverterType(state, props);
  const currenciesIsFetching = getCurrenciesFetching(state);
  const currenciesItems = getCurrenciesItems(state);
  const converterTypesOptions = getConverterTypesOptions(state, props);
  const ratesIsFetching = getCurrencyRatesIsFetching(state);

  return {
    ...locationParamsValues,
    ...currencyRatesByCurrencyPair,
    ...currenciesPairInfo,
    timestamp,
    existedConverterType,
    currenciesIsFetching,
    currenciesItems,
    converterTypesOptions,
    ratesIsFetching,
  };
};

const CurrencyConverterContainer = injectIntl(
  withRouter(connect(mapStateToProps)(FullCurrencyConverter))
);

export default CurrencyConverterContainer;
